import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import commonV1 from './commons/v1/common'
import ModalAlertV1 from '@/components/v1/Modal/Alert'
import jQuery from 'jquery'
import { createPinia } from 'pinia'

global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')

const app = createApp(App)
app.use(router)
app.use(store)

const pinia = createPinia()
app.use(pinia)

app.component('modal-alert-v1', ModalAlertV1)

if (window.location.href.match(/v1/)) {
  app.mixin(commonV1)
} else {
  app.mixin(commonV1)
}

app.config.globalProperties.$filters = {
  addComma (val) {
    return val.toLocaleString()
  }
}

app.mount('#app')
